import { type TimezonesDataSets } from '../datasets/timezones';
import useAsyncImportDataSets from './useAsyncImportDataSets';

const useTimeZoneList = () => {
    const { loading, data } = useAsyncImportDataSets('timezones');

    return { loading, data: (data ?? []) as TimezonesDataSets };
};

export default useTimeZoneList;
